import React, { useEffect, useRef, useState } from 'react';
import './levels.css';
import './levels2.css';
import { useNavigate } from 'react-router-dom';

import Settings from '../components/common/settings';

import lockedSound from '../audios/mixkit-click-error-1110.wav';
import settingsSound from '../audios/settoings.wav';

const Levels4 = () => {
  const navigate = useNavigate();

  const [loaded, setLoaded] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);

  const [level7Unlocking, setLevel7Unlocking] = useState(false);
  const [level7Unlocked, setLevel7Unlocked] = useState(false);

  const lockedAudio = useRef(new Audio(lockedSound));
  const settingsAudio = useRef(new Audio(settingsSound));

  useEffect(() => {
    setLoaded(true);

    const t1 = setTimeout(() => {
      setLevel7Unlocking(true);

      setTimeout(() => {
        setLevel7Unlocked(true);
        setLevel7Unlocking(false);
      }, 1400);
    }, 1800);

    return () => clearTimeout(t1);
  }, []);

  const playLockedSound = () => {
    lockedAudio.current.currentTime = 0;
    lockedAudio.current.play().catch(() => {});
  };

  const playSettingsSound = () => {
    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  return (
    <section className="section2 levels4page">
      <div className="overlay"></div>
      <div className="fog"></div>
      <div className="flicker-overlay"></div>

      <div className="levelsnav">
        <button
          className="backbt"
          onClick={() => {
            playSettingsSound();
            navigate(-1);
          }}
        >
          BACK
        </button>

        <h1 className="mysteryhotel">
          MYSTERY HOTEL
        </h1>

        <div
          className="settings"
          onClick={() => {
            playSettingsSound();
            setOpenSettings(true);
          }}
        />
      </div>

      <h1 className="pickurroom">
        PICK YOUR ROOM
      </h1>

      <div className="levelsdiv">
        <div className={`level2 ${loaded ? 'enter' : ''}`} onClick={playLockedSound}>
          <div className="lock"></div>
        </div>

        <div className={`level3 ${loaded ? 'enter' : ''}`} onClick={playLockedSound}>
          <div className="lock"></div>
        </div>

        <div className={`level4 ${loaded ? 'enter' : ''}`} onClick={playLockedSound}>
          <div className="lock"></div>
        </div>
        <div
          className={`level1 ${loaded ? 'enter' : ''} unlocked`}
          onClick={() => navigate('/room3')}
        />

        <div
          className={`level5 ${loaded ? 'enter' : ''} unlocked`}
          onClick={() => navigate('/story')}
        />

        <div
          className={`level6 ${loaded ? 'enter' : ''} unlocked`}
          onClick={() => navigate('/room2')}
        />

        <div
          className={`level7 ${loaded ? 'enter' : ''} ${
            level7Unlocking ? 'unlocking' : ''
          } ${level7Unlocked ? 'unlocked' : ''}`}
          onClick={
            level7Unlocked
              ? () => navigate('/room4')
              : playLockedSound
          }
        >
          {!level7Unlocked && (
            <div
              className={`lock ${
                level7Unlocking ? 'lock-shatter' : ''
              }`}
            />
          )}
        </div>
      </div>

      <Settings
        open={openSettings}
        onClose={() => {
          playSettingsSound();
          setOpenSettings(false);
        }}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />
    </section>
  );
};

export default Levels4;